import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { INTENT_CTA_COPY } from "../../lib/survey-schema";
import { Button } from "../shared/Button";

export function IntentCTA({ waitlist }) {
    const navigate = useNavigate();
    const copy = INTENT_CTA_COPY[waitlist] ?? INTENT_CTA_COPY.maybe;
    return (
        <div
            className="rounded-3xl border border-klareet-T/40 bg-gradient-to-br from-klareet-T/10 to-klareet-T2/5 p-8 md:p-10 animate-fade-up"
            data-testid="intent-cta"
        >
            <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-T2 font-mono">
                What happens next
            </div>
            <p className="mt-4 text-xl md:text-2xl text-klareet-TEXT leading-snug max-w-2xl">
                {copy}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
                <Button
                    size="lg"
                    variant="primary"
                    onClick={() => navigate("/results")}
                    data-testid="see-others-btn"
                >
                    See how others responded
                    <ArrowRight size={18} />
                </Button>
                <Button
                    size="lg"
                    variant="outline"
                    onClick={() => navigate("/")}
                    data-testid="back-home-btn"
                >
                    Back to start
                </Button>
            </div>
        </div>
    );
}
